import * as constantConfig from '../utilities/constant_config';

const clsParentInsurance = '.checkout-insurance';
const addhealthInsuranceContainerId = '#show-add-health-insurance';
const clsInsuranceErrorSection = '.checkout-insurance__error';
const clsSaveBtn = '.insurance-save-btn';
const insNextBtnId = '#ins-next-btn';
const insuranceErrorsId = '#insurance-errors';
const clsAddExpInsRadio = '.insurance-res-options__option';
const clsCheckoutmainErrorMsg = '.insurance-error-msg--main';
const clsCheckoutInsErrorMsg = '.insurance-option-wrapper__msg';
const clsCheckoutInsErrorSubDesc = '.insurance-option-wrapper__subdesc';
const clsCheckoutInsEditable = '.insurance-checkout__editable';
const clsCheckoutInsField = '.insurance-option-wrapper__field';
const clsCheckoutInsDisImg = 'add-insurance-img--disabled';
const clsCheckoutInsDisText = 'add-insurance-text--disabled';
const addInsuranceImgClass = 'add-insurance-img';
const addInsuranceTextInnerClass = 'add-insurance-text__inner';
const clsCheckoutHealthInsurance = '.account-health-insurance';
const clsAddInsPolicyInfo = '.account-health-insurance-policy-info';
const clsErrorMsgTextBox = '.error-msg-textbox';
const clsErrorMsgText = '.error-msg-text';
const strErrorMsgTextBox = 'error-msg-textbox';
const clsCheckoutInsuranceState = '.health-add-insurance__select-state';
const clsCheckoutInsResultsSection = '.health-add-insurance-search-section';
const clsCheckoutAddInsuranceSection =
  '.health-remove-insurance-addnew-section';
const clsCheckoutSelectMenutTxt = '.ui-selectmenu-text';
const healthInsuranceSearchForm = '#health-add-insurance';
const fromNoPayer = constantConfig.FROM_NO_PAYER;
const fromInsuranceView = constantConfig.FROM_INSURANCE_VIEW;
const fromErrorTile = constantConfig.FROM_ERROR_TILE;
const $insuranceErrorSections = $(clsInsuranceErrorSection);
const selectClass = '.insurance-option-wrapper__field--select';
var $spinner = $('#health-add-insurance .spinner-mask');

let newInsuranceSelectedTile;

// To decide whether the Next button should be enabled on click of the Save button
export function enableDisableNextStep() {
  const errorSectionsLength = $insuranceErrorSections.length;
  const $resolvedSections = $insuranceErrorSections.find(
    `${clsSaveBtn}:disabled`
  );
  let resolvedSection = 0;
  $resolvedSections.each((index, item) => {
    const dataAttribute = $(item).data('action');
    if (dataAttribute === '' || dataAttribute === undefined) {
      return false;
    }
    resolvedSection += 1;
    return true;
  });
  // Checking whether the Next button has to be enabled
  if (errorSectionsLength && resolvedSection === errorSectionsLength) {
    $(insNextBtnId).attr('disabled', false);
    // hide the main error message
    $(clsCheckoutmainErrorMsg).hide();
  } else {
    $(insNextBtnId).attr('disabled', true);
  }
}

export function setNewInsuranceSelectedTile(newInsuranceSelected) {
  newInsuranceSelectedTile = newInsuranceSelected;
}
export function getNewInsuranceSelectedTile() {
  return newInsuranceSelectedTile;
}

export function afterSuccessfulResolution() {
  const parentContainer = getNewInsuranceSelectedTile();
  const radioButtons = $(parentContainer).find(clsAddExpInsRadio);
  const errorMsg = $(parentContainer).find(clsCheckoutInsErrorMsg);
  const errorSubMsg = $(parentContainer).find(clsCheckoutInsErrorSubDesc);
  const resolveButton = $(parentContainer).find(clsSaveBtn);
  const editableSection = $(parentContainer).find(clsCheckoutInsEditable);

  const editableFields = $(parentContainer).find(clsCheckoutInsField);
  const selectFields = $(parentContainer).find(selectClass);
  // Disable editable fields
  if (editableSection.length) {
    $(editableFields).attr('disabled', true);
    selectFields.selectmenu('disable');
  }
  // Disable save button
  $(resolveButton).attr('disabled', true);
  // Disabling radio buttons
  $(radioButtons).attr('disabled', true);
  // Hide error messages
  $(errorMsg).hide();
  $(errorSubMsg).hide();
  enableDisableNextStep();
}

function resetCheckoutAddInsuranceForm() {
  const preSelectedState = $(
    `${addhealthInsuranceContainerId} ${clsCheckoutInsuranceState}`
  ).find('option[data-val="selected"]');
  // reset search form
  $(`${addhealthInsuranceContainerId} ${healthInsuranceSearchForm}`).trigger(
    'reset'
  );
  $(`${clsParentInsurance} ${clsCheckoutInsuranceState}`)
    .find('option[selected="selected"]')
    .removeAttr('selected');
  $(`${addhealthInsuranceContainerId} ${clsCheckoutSelectMenutTxt}`).text(
    $(preSelectedState).text()
  );
  // resetting error msgs in form
  $(`${addhealthInsuranceContainerId} ${clsErrorMsgTextBox}`).removeClass(
    strErrorMsgTextBox
  );
  $(`${addhealthInsuranceContainerId} ${clsErrorMsgText}`).attr('hidden', true);
  // reset dropdown value to billing address auto populated state
  $(preSelectedState).attr('selected', true);
  // reset search results html
  $(`${addhealthInsuranceContainerId} ${clsCheckoutInsResultsSection}`).html(
    ''
  );
}

export function addHealthInsurance(thisObj, insuranceObject = {}) {
  $spinner.prop('hidden', true);
  const thisParamObj = thisObj.type ? $(this) : thisObj;
  const disabledImgClass = $(thisParamObj).hasClass(clsCheckoutInsDisImg);
  const disabledTextClass = $(thisParamObj).hasClass(clsCheckoutInsDisText);
  if (!disabledImgClass && !disabledTextClass) {
    const addInsuranceFromView = $(this).parents(clsAddInsPolicyInfo).length;
    const addInsuranceNoPayer =
      ($(thisParamObj).hasClass(addInsuranceImgClass) ||
        $(thisParamObj).hasClass(addInsuranceTextInnerClass)) &&
      !addInsuranceFromView;
    let parentStr = fromErrorTile;
    parentStr = addInsuranceNoPayer ? fromNoPayer : parentStr;
    parentStr = addInsuranceFromView ? fromInsuranceView : parentStr;

    $(insuranceErrorsId).hide();
    $(clsCheckoutHealthInsurance).hide();
    resetCheckoutAddInsuranceForm();
    $(addhealthInsuranceContainerId).data('parent', parentStr);
    $(addhealthInsuranceContainerId).data('requiredInsurance', insuranceObject);
    $(clsCheckoutAddInsuranceSection).show();
    $(addhealthInsuranceContainerId).show();
    $('#t1_insuranceType').focus();
  }
}
